import React from 'react';
import { Info } from 'lucide-react';

const ContactoUbicacion = ({ data, handlers }) => {
    return (
        <div className="bg-white rounded-2xl p-5 md:p-6 shadow-sm border border-slate-100">
            <div className="flex items-center gap-2 mb-4 border-b border-slate-100 pb-3">
                <Info className="w-4 h-4 text-blue-600" />
                <h2 className="text-base font-semibold text-slate-800">Contacto y Ubicación</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div>
                    <label className="block text-xs font-medium text-slate-700 mb-1">Dirección Principal</label>
                    <input 
                        type="text"
                        className="w-full px-3 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm"
                        value={data.direccion}
                        onChange={(e) => handlers.setDireccion(e.target.value)}
                    />
                </div>
                <div>
                    <label className="block text-xs font-medium text-slate-700 mb-1">Provincia</label>
                    <input 
                        type="text"
                        className="w-full px-3 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm"
                        value={data.provincia}
                        onChange={(e) => handlers.setProvincia(e.target.value)}
                    />
                </div>
                <div>
                    <label className="block text-xs font-medium text-slate-700 mb-1">Cantón</label>
                    <input 
                        type="text"
                        className="w-full px-3 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm"
                        value={data.canton}
                        onChange={(e) => handlers.setCanton(e.target.value)}
                    />
                </div>
                <div>
                    <label className="block text-xs font-medium text-slate-700 mb-1">Parroquia</label>
                    <input 
                        type="text"
                        className="w-full px-3 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm"
                        value={data.parroquia}
                        onChange={(e) => handlers.setParroquia(e.target.value)}
                    />
                </div>
                <div>
                    <label className="block text-xs font-medium text-slate-700 mb-1">Comunidad / Barrio</label>
                    <input 
                        type="text"
                        className="w-full px-3 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm"
                        value={data.comunidad}
                        onChange={(e) => handlers.setComunidad(e.target.value)}
                    />
                </div>
                <div>
                    <label className="block text-xs font-medium text-slate-700 mb-1">Teléfono Institucional</label>
                    <input 
                        type="tel"
                        className="w-full px-3 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm"
                        value={data.telefono}
                        onChange={(e) => handlers.setTelefono(e.target.value)}
                    />
                </div>
                <div>
                    <label className="block text-xs font-medium text-slate-700 mb-1">Email Institucional</label>
                    <input 
                        type="email"
                        className="w-full px-3 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm"
                        value={data.email}
                        onChange={(e) => handlers.setEmail(e.target.value)}
                    />
                </div>
            </div>
        </div>
    );
};

export default ContactoUbicacion;
